import {
  ActionButton,
  OfficeHeader,
  Show,
  TableComponent,
  TableLoader,
} from "components";
import { useKEKOffer, useOffer } from "hooks/data/use-offers";
import { useMatch, useNavigate, useSearch } from "react-location";

import { Action } from "components/buttons/action-button";
import { FC } from "react";
import { LocationGenerics } from "router/location";
import OfferTransactionThreadContainer from "pages/view-offer/components/offer-transaction-thread";
import SendEmailsContainer from "./send";
import ViewNoteContainer from "./view";
import numeral from "numeral";
import { useUpdateBubble } from "hooks/data/use-update-bubble";
import { useUrlState } from "utils";

type Props = {};

const CreditNotesPage: FC<Props> = (props) => {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useSearch<LocationGenerics>();
  const [modal, setModal] = useUrlState("modal");
  const navigate = useNavigate<LocationGenerics>();
  const { updateBubble } = useUpdateBubble();

  const { loading, offer, refetch } = useKEKOffer({
    offer_id: params?.offer || "",
  });

  const updateThreadBubble = (ids: string[]) => {
    updateBubble({
      variables: {
        ids,
      },
    })
      .then(() => { })
      .catch((err) => { });
  };

  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
      () => {
        navigate({
          search: (old) => ({
            ...old,
            id,
            modal: action,
          }),
        });
      };

  return (
    <div>
      <OfficeHeader />

      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            loading={loading}
            title={"credit notes"}
            columns={[
              {
                name: "Company Name",
                accessor: "reinsurer.re_company_name",
              },
              {
                name: "Company Email",
                accessor: "reinsurer.re_company_email",
              },
              {
                name: "Reinsurer Amount",
                accessor: "offer_amount",
                render: (value) => (
                  <>
                    {offer?.offer_detail?.currency}{" "}
                    {numeral(value?.offer_amount).format("0,0.00")}
                  </>
                ),
              },
              {
                name: "Participant %",
                accessor: "offer_participant_percentage",
              },
              {
                name: "Action",
                accessor: "actions",
                render: (value) => (
                  <>
                    <ActionButton
                      action={"clone"}
                      tooltip="Generate Closing Docs"
                      onClick={dispatchAction(
                        value?.offer_participant_id || "",
                        "view"
                      )}
                    />
                    <ActionButton
                      action={"send"}
                      disabled={Boolean(offer?.approval_status === "UNAPPROVED")}
                      onClick={dispatchAction(
                        value?.reinsurer?.reinsurer_id || "",
                        "send"
                      )}
                    />
                    <Show if={Boolean(value?.offer_published_participant?.offer_published_participant_id)}>
                      <ActionButton
                        action="chat"
                        tooltip="View Message Thread"
                        onClick={dispatchAction(
                          value?.offer_published_participant?.offer_published_participant_id || "",
                          "chat"
                        )}
                        count={
                          value.thread_notification?.filter(
                            (item: any) => item?.status !== "READ"
                          ).length
                        }
                        callBack={() =>
                          updateThreadBubble(
                            value.thread_notification?.map(
                              (item: any) => item?.id || ""
                            ) || []
                          )
                        }
                      />
                    </Show>
                  </>
                ),
              },
            ]}
            data={offer?.offer_participant || []}
            renderLoader={() => <TableLoader items={[1, 1, 1, 1, 1]} />}
            refetch={refetch}
          />
        </div>
      </div>

      {searchParams.id && modal === "view" && (
        <ViewNoteContainer
          open={modal === "view"}
          setOpen={(val: boolean) => setModal(val ? "view" : undefined)}
        />
      )}

      {searchParams.id && modal === "send" && (
        <SendEmailsContainer
          open={modal === "send"}
          setOpen={(val: boolean) => setModal(val ? "send" : undefined)}
        />
      )}
      {searchParams.id && modal === "chat" && (
        <OfferTransactionThreadContainer
          open={modal === "chat"}
          setOpen={(val: boolean) => setModal(val ? "chat" : undefined)}
        />
      )}
    </div>
  );
};

export default CreditNotesPage;
